import React, { useState } from 'react'
import _ from 'lodash'
import cn from 'classnames'

/*
<Table
  rowKey={record => record.id}
  columns={[{ 
    key: 'id', 
    header: 'Some ID',
    style: {},
    render: ({ id }) => <div>{id}</div>
  }]}
  data={[{ id: '123' }]}
/>
*/

let columnDefaults = ({ render, showSort = true, ...col }) => {
  let getValue = data => data[col.key]
  return {
    key: '',
    header: '', // or can be () =>
    style: {},
    className: '',
    render: render || getValue,
    getValue,
    showSort,
    ...col,
  }
}

let Table = ({
  containerClassName = '',
  className = 'table-sm',
  rowKey = record => record.id,
  columns: columnsParam,
  data,
  emptyText = 'No data found.',
  initialSort = {
    order: 'asc',
    index: 0,
  },
  rowStyle = () => ({}),
}) => {
  let columns = columnsParam.map(c => {
    let col = columnDefaults(c)
    let header = _.isFunction(col.header) ? col.header() : col.header
    return { ...col, header }
  })

  let [sortConfig, setSortConfig] = useState(initialSort)

  if (_.isEmpty(data)) {
    return <div className="text-center">{emptyText}</div>
  }

  let orderedData = _.sortBy(data, record => {
    let val = columns[sortConfig.index].getValue(record)
    return sortConfig.order === 'asc' ? val : -val
  })

  return (
    <div className={containerClassName}>
      <table className={`table ${className}`}>
        <thead>
          <tr>
            {columns.map((col, index) => {
              let hasSort = sortConfig.index === index

              return (
                <th key={index}>
                  <div className={col.className || ''} style={col.style}>
                    {col.header}{' '}
                    {col.showSort && (
                      <i
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          setSortConfig({
                            index,
                            order:
                              hasSort && sortConfig.order === 'asc'
                                ? 'desc'
                                : 'asc',
                          })
                        }}
                        className={cn('fa', {
                          'fa-sort': !hasSort,
                          'fa-sort-up': hasSort && sortConfig.order === 'asc',
                          'fa-sort-down':
                            hasSort && sortConfig.order === 'desc',
                        })}
                      />
                    )}
                  </div>
                </th>
              )
            })}
          </tr>
        </thead>
        <tbody>
          {orderedData.map((record, rowIndex) => {
            return (
              <tr
                key={rowKey(record, rowIndex)}
                style={rowStyle(record, rowIndex)}
              >
                {columns.map((c, colIndex) => (
                  <td key={c.key} className={c.className || ''} style={c.style}>
                    {c.render
                      ? c.render(record, rowIndex, colIndex)
                      : record[c.key]}
                  </td>
                ))}
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}

export default Table
